<div
  class="py-xs hover:bg-background-underground-2 px-md group/item flex cursor-pointer flex-nowrap items-center rounded-md"
  [cdkDragDisabled]="!peutModifier()"
  [cdkDragData]="aptitude()"
  [draggable]="peutModifier()"
  routerLinkActive="component-medium-semibold [&>span]:text-components-content-primary-darker bg-components-background-primary-lightest hover:bg-components-background-primary-lightest"
  cdkDrag
>
  <span
    class="text-content-secondary flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
    [routerLink]="['.']"
    [queryParams]="{ idAptitude: aptitude().id }"
    [hlmTooltipTrigger]="aptitude().nom"
    >{{ aptitude().nom }}</span
  >
  <div class="gap-xxs flex">
    @if (peutModifier()) {
      <div class="invisible group-hover/item:visible" cardItemActions>
        <button
          [hlmDropdownMenuTrigger]="actionsMenu"
          [hlmDropdownMenuTriggerData]="{ $implicit: { item: aptitude() } }"
          hlmBtn
          variant="ghost"
          size="icon"
        >
          <ng-icon name="lucideEllipsisVertical" />
        </button>
      </div>
    }
    <app-chip [label]="productionLabel()" />
    <app-chip [label]="indiceLabel()" />
  </div>
</div>

<ng-template #actionsMenu let-ctx>
  <hlm-dropdown-menu hlmDropdownMenuItem>
    @for (action of aptitudeActions; track $index) {
      <button (triggered)="action.action(ctx.item)" hlmDropdownMenuItem>
        <ng-icon [name]="action.icon" />
        {{ action.label }}
      </button>
    }
  </hlm-dropdown-menu>
</ng-template>
